import { useSelector, useDispatch } from 'react-redux';
import { ModalConfirm } from '@components/Modal';
import { useTranslation } from '@hooks';
import { contactsService } from '@services';
import { handleApiError } from '@helpers/api';
import { contactsActions, alertActions } from '@actions';
import { ModalType } from '@constants/modal';

const ContactDeleteModal = ({ onDeleteCallback, open }) => {
    const { contact, contactDrawerOpened, contactEditModal } = useSelector(state => state.contacts);

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const onDeleteContact = async () => {
        try {
            await contactsService.deleteContact(contact?.id);
            if (onDeleteCallback) {
                onDeleteCallback();
            }
            dispatch(alertActions.success(t('alertMessages.deleteSuccess')));
        } catch (error) {
            handleApiError(error, 'alertMessages.deleteFail');
        } finally {
            if (contactEditModal.open) {
                dispatch(contactsActions.setContactEditModal({ open: false, type: ModalType.Create }));
            }
            dispatch(contactsActions.setContactDeleteModal(false));
            if (contactDrawerOpened) {
                dispatch(contactsActions.setContactDrawer(false));
            }
            dispatch(contactsActions.setContact(null));
        }
    };

    const onCloseDeleteModal = () => dispatch(contactsActions.setContactDeleteModal(false));

    return (
        <ModalConfirm
            isOpen={open}
            handleClose={onCloseDeleteModal}
            title={t('common.deleteTitle')}
            description={t('common.deleteDescription')}
            onPrimaryAction={onDeleteContact}
            primaryActionText={t('buttons.delete')}
            primaryActionType="danger"
        />
    );
};

export default ContactDeleteModal;
